import { render, staticRenderFns } from "./ForageImporter.vue?vue&type=template&id=22ac8408&scoped=true&lang=html&"
import script from "./ForageImporter.vue?vue&type=script&lang=js&"
export * from "./ForageImporter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ac8408",
  null
  
)

export default component.exports